export default __webpack_public_path__ + "static/media/new-player.3b8f9f96.svg";